/**
 * Serialize flat row objects to a CSV string (comma separated, header from first row's keys).
 * Values are NOT escaped/quoted — callers must ensure they contain no commas or newlines.
 * @param exportData - Rows to export; all rows should share the first row's key set.
 * @returns CSV text, or the literal string 'no data' when there are no rows.
 */
export function createCSVDownload(exportData: Array<Record<string, any>> | null | undefined): string {
  if (!exportData?.length) return 'no data';
  let csv = '';
  // headline for csv from json keys
  csv += Object.keys(exportData[0]).join(',') + '\n';
  // loop through json data
  exportData.forEach(function (row) {
    csv += Object.values(row).join(',') + '\n';
  });
  return csv;
}

/**
 * Build a (not yet attached) anchor element that downloads the given CSV text.
 * @param csv - CSV file content.
 * @param name - Download file name without the '.csv' extension.
 */
export function createDownloadWithCSV(csv: string, name: string): HTMLAnchorElement {
  const anchor = document.createElement('a');
  anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
  anchor.target = '_blank';

  anchor.download = `${name}.csv`;
  return anchor;
}

/**
 * Build an export file name from a date range.
 * @param dateRange - [start, end] moment objects (typed structurally to avoid a hard moment dependency).
 * @returns e.g. 'export-2026-01-01-2026-01-31'.
 */
export function getNameWithDateRange(dateRange: Array<{ format(fmt: string): string }>): string {
  return `export-${dateRange[0].format('YYYY-MM-DD')}-${dateRange[1].format(
    'YYYY-MM-DD'
  )}`;
}
